/* XTRACTD – video autoplay when visible. No dependencies. */
if (!customElements.get('xtractd-video')) {
  customElements.define(
    'xtractd-video',
    class XtractdVideo extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        this.video.muted = true;
        this.video.playsInline = true;

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        if (reduceMotion.matches) return;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (this.video.preload === 'none') this.video.preload = 'auto';
                const playPromise = this.video.play();
                if (playPromise) playPromise.catch(() => {});
              } else {
                this.video.pause();
              }
            });
          },
          { rootMargin: '200px 0px', threshold: 0.01 }
        );

        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}

/* XTRACTD – filter drawer (native <dialog>) */
(function () {
  const lock = (on) => document.documentElement.classList.toggle('xt-scroll-lock', on);

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-xt-drawer-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.xtDrawerOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
        lock(true);
      }
      return;
    }

    const closer = event.target.closest('[data-xt-drawer-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog) dialog.close();
      return;
    }

    // Click on the backdrop (the dialog element itself) closes the drawer
    if (event.target.matches && event.target.matches('dialog[data-xt-drawer]')) {
      event.target.close();
    }
  });

  document.addEventListener(
    'close',
    (event) => {
      if (event.target.matches && event.target.matches('dialog[data-xt-drawer]')) lock(false);
    },
    true
  );
})();

/* XTRACTD – auto submit (inline filters + sort select) */
(function () {
  const submit = (form) => {
    if (!form) return;
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  };

  document.addEventListener('change', (event) => {
    const target = event.target;

    if (target.matches('[data-xt-autosubmit-select]')) {
      submit(target.form);
      return;
    }

    const form = target.closest('form[data-xt-autosubmit]');
    if (form) submit(form);
  });

  // Remove empty params so URLs stay clean
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.xt-bar form, form.xt-drawer__form, form[id^="XtFilter"]')) return;
    if (form.method.toLowerCase() !== 'get') return;

    event.preventDefault();
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (value !== '') params.append(key, value);
    });
    const query = params.toString();
    window.location.href = form.action.split('?')[0] + (query ? '?' + query : '');
  });
})();

/* XTRACTD – desktop dropdowns: one open at a time, close on outside click / Escape */
(function () {
  const closeAll = (except) => {
    document.querySelectorAll('details[data-xt-dd][open]').forEach((el) => {
      if (el !== except) el.removeAttribute('open');
    });
  };

  document.addEventListener(
    'toggle',
    (event) => {
      const el = event.target;
      if (el.matches && el.matches('details[data-xt-dd]') && el.open) closeAll(el);
    },
    true
  );

  document.addEventListener('click', (event) => {
    if (!event.target.closest('details[data-xt-dd]')) closeAll(null);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('details[data-xt-dd][open]');
    if (open) {
      open.removeAttribute('open');
      const summary = open.querySelector('summary');
      if (summary) summary.focus();
    }
  });
})();

/* XTRACTD – sticky bar sits directly below a sticky/fixed theme header */
(function () {
  const init = () => {
    const bar = document.querySelector('[data-xt-sticky-auto]');
    if (!bar) return;
    const wrapper = bar.closest('.shopify-section') || bar.parentElement;

    const candidates = () =>
      document.querySelectorAll(
        '.shopify-section-group-header-group, .shopify-section-group-header-group > *, .shopify-section-group-header-group > * > *, #shopify-section-header, header'
      );

    let ticking = false;
    const update = () => {
      ticking = false;
      let offset = 0;
      candidates().forEach((el) => {
        if (el === wrapper || wrapper.contains(el)) return;
        const pos = getComputedStyle(el).position;
        if (pos !== 'fixed' && pos !== 'sticky') return;
        const rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.top <= 1 && rect.bottom > offset) offset = rect.bottom;
      });
      wrapper.style.setProperty('--xt-bar-top', Math.max(0, Math.round(offset)) + 'px');
    };

    const request = () => {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    update();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();